<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="isRouterAlive"></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'App',
        provide () {
            return {
                reload: this.reload,
            }
        },
        data () {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style>
    .context-menu-list :hover {
        background-color: #ecf5ff;
        color: #66b1ff;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue